import { DropDownFilter } from "components/InputsMex/inputs";
import { getQueryParams } from "utils/funciones";
import logoGarantia from "../img/aiggo_garantia.png";
import React from "react";

const qParams = getQueryParams();

const SeleccionarTienda = ({
  canales,
  paraComenzar,
  avisoPrivacidad,
  buscarFecha,
  isQrTienda,
  loading,
}) => {
  return (
    <div className='container__inicio w-100 d-flex flex-row flex-wrap'>
      <div className='slide left_slide d-flex flex-column'>
        <div className='mt-auto mb-5'>
          <h1 className='title ml-5'>¡Extiende la vida de tus electrodomésticos!</h1>
          <h1 className='big-title ml-5'>Garantía Extendida</h1>
          <h1 className='small-title ml-5'>Con el respaldo de</h1>
          <img src={logoGarantia} className='logo' alt='' />
        </div>
      </div>
      <div className='slide right_slide d-flex flex-column justify-content-center align-content-center'>
        <div className='formbox align-self-center'>
          <div className='mx-4 my-3'>
            <p>{paraComenzar}</p>
            <div className='form__control'>
              <h5>Ingresa el canal de venta</h5>
              <hr className='divisor' />
              <DropDownFilter
                name='canal'
                options={canales}
                onChangeFn={buscarFecha}
                disabled={isQrTienda || !!qParams.canal || loading}
                loading={loading}
              />
            </div>
            <a className='text-white' href={avisoPrivacidad} target='__blank'>
              Consulta aviso de privacidad aquí
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeleccionarTienda;
